import React from 'react';
import './PolicyModal.css';

const PrivacyContent = () => (
  <>
    <h2>Privacy Policy</h2>
    <p><strong>Last updated: March 2026</strong></p>

    <h3>1. Information We Collect</h3>
    <p>We collect personal information you provide during registration including your name, email address, phone number, date of birth, gender, marital status, and profile details such as religious background, professional information, family details, lifestyle preferences, and photographs.</p>

    <h3>2. How We Use Your Information</h3>
    <p>Your information is used to create and manage your matrimonial profile, match you with potential partners, verify your identity via OTP, process wallet transactions and payments, and communicate important updates about your account.</p>

    <h3>3. Information Sharing</h3>
    <p>Your contact details (phone and email) are hidden from other users by default. When another user wishes to view your contact information, they must pay 100 coins from their wallet balance to unlock it. The amount is deducted from the viewing user's account, not yours. Once unlocked, your contact details remain visible to that user permanently. We do not sell your personal data to third parties. We may share data with payment processors (Razorpay) and SMS providers (Twilio) solely for service delivery.</p>

    <h3>4. Photo Privacy</h3>
    <p>All uploaded photos require admin approval before being visible to other users. We implement measures to discourage unauthorized downloading of profile photos, though absolute prevention is not possible on the web.</p>

    <h3>5. Data Security</h3>
    <p>We use industry-standard security measures including encrypted passwords, secure API authentication via tokens, and hashed OTP storage. However, no method of electronic transmission is 100% secure.</p>

    <h3>6. Data Retention</h3>
    <p>Your data is retained as long as your account is active. You may request account deletion by contacting our support team at support.manthrakodi@gmail.com.</p>

    <h3>7. Contact Us</h3>
    <p>For privacy-related queries, contact us at:<br />
    Manthrakodi Matrimoni, Kannadiparamba, Kannur 670604, Kerala<br />
    Email: support.manthrakodi@gmail.com</p>
  </>
);

const TermsContent = () => (
  <>
    <h2>Terms and Conditions</h2>
    <p><strong>Last updated: March 2026</strong></p>

    <h3>1. Acceptance of Terms</h3>
    <p>By registering on Manthrakodi Matrimony, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>

    <h3>2. Eligibility</h3>
    <p>You must be at least 18 years of age to register. By creating an account, you confirm that the information provided is accurate and truthful.</p>

    <h3>3. Account Responsibilities</h3>
    <p>You are responsible for maintaining the confidentiality of your account credentials. You must not share your account with others or create multiple accounts. Any activity under your account is your responsibility.</p>

    <h3>4. Profile Content</h3>
    <p>You agree to provide accurate information in your profile. Uploading false, misleading, or offensive content is prohibited. All photos are subject to admin review and approval before being visible to other users.</p>

    <h3>5. Wallet and Payments</h3>
    <p>Wallet recharges are processed through Razorpay. 1 Rupee = 1 Coin. To view another user's contact details (phone number and email), you must unlock them by paying 100 coins from your wallet balance. The amount is deducted from your (the viewer's) account at the time of unlocking. Once unlocked, the contact details remain accessible to you permanently. Wallet coins are non-refundable and non-transferable. Manthrakodi reserves the right to adjust wallet balances in case of errors or fraudulent activity.</p>

    <h3>6. Prohibited Conduct</h3>
    <p>You must not use the platform for harassment, fraud, or any unlawful purpose. Downloading, copying, or distributing other users' photos without consent is strictly prohibited. Attempting to bypass security measures or access other users' accounts is forbidden.</p>

    <h3>7. Account Suspension</h3>
    <p>Manthrakodi reserves the right to suspend or delete accounts that violate these terms, contain fraudulent information, or are reported for misconduct.</p>

    <h3>8. Limitation of Liability</h3>
    <p>Manthrakodi acts as a platform to connect individuals and does not guarantee the accuracy of user profiles or the outcome of any interactions. We are not liable for any disputes between users.</p>

    <h3>9. Changes to Terms</h3>
    <p>We may update these terms from time to time. Continued use of the platform after changes constitutes acceptance of the updated terms.</p>

    <h3>10. Contact</h3>
    <p>For questions about these terms, contact us at:<br />
    Manthrakodi Matrimoni, Kannadiparamba, Kannur 670604, Kerala<br />
    Email: support.manthrakodi@gmail.com</p>
  </>
);

const PolicyModal = ({ type, onClose }) => {
  return (
    <div className="policy-overlay" onClick={onClose}>
      <div className="policy-modal" onClick={e => e.stopPropagation()}>
        <button className="policy-close" onClick={onClose}>✕</button>
        <div className="policy-content">
          {type === 'privacy' ? <PrivacyContent /> : <TermsContent />}
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
